"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

const GA_MEASUREMENT_ID = "G-88R82Y7H45";

export function GoogleAnalyticsPageViews() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastLocationRef = useRef(null);
  const queryString = searchParams.toString();

  useEffect(() => {
    const pagePath = queryString ? `${pathname}?${queryString}` : pathname;
    if (!pathname || lastLocationRef.current === pagePath) return;

    lastLocationRef.current = pagePath;
    window.gtag?.("event", "page_view", {
      send_to: GA_MEASUREMENT_ID,
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, queryString]);

  return null;
}
